import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { env } from './enviorments'

Vue.use(Vuex)

const get = async (endpoint) => {
    const result = await axios.get(env.apiUrl + endpoint)
    if (result.status === 200) return result.data
    else return false
}

export default new Vuex.Store({
    state: {
        slides: [],
        main: null,
        home: null,
        about: null,
        brands: [],
        showroom: null,
        car: null,
        workshop: null,
        training: null,
        news: null,
        recentNews: [],
        productions: null,
        production: null,
        categories: null,
    },
    getters: {
        getShowroom: state => {
            if (!state.showroom) return
            return {
                ...state.showroom,
                phones: state.showroom.phone.split('<br>'),
                email_website: state.showroom.email_website.split('<br>'),
            }
        },
        getWorkshop: state => {
            if (!state.workshop) return
            return {
                ...state.workshop,
                phones: state.workshop.phone.split('<br>'),
                email_website: state.workshop.email_website.split('<br>'),
            }
        },
        getTraining: state => {
            if (!state.training) return
            return {
                ...state.training,
                phones: state.training.phone.split('<br>'),
                email_website: state.training.email_website.split('<br>'),
            }
        },
        getProduction: state => {
            if (!state.production) return
            return {
                ...state.production,
                phones: state.production.phone.split('<br>'),
                email_website: state.production.email_website.split('<br>'),
            }
        },
        getNews: state => (state.news ? [...state.news.data] : []),
        getNewsTotal: state => (state.news ? Math.ceil(state.news.meta.total / state.news.meta.per_page) : 1)
    },
    mutations: {
        updateMain(state, main) {
            state.main = main
        },
        updateHome(state, home) {
            state.home = home
        },
        updateAbout(state, about) {
            state.about = about
        },
        updateBrands(state, brands) {
            state.brands = brands
        },
        updateShowroom(state, showroom) {
            state.showroom = showroom
        },
        updateCar(state, car) {
            state.car = car
        },
        updateWorkshop(state, workshop) {
            state.workshop = workshop
        },
        updateTraining(state, training) {
            state.training = training
        },
        updateProductions(state, productions) {
            state.productions = productions
        },
        updateProduction(state, production) {
            state.production = production
        },
        updateCategory(state, categories) {
            state.categories = categories
        },
        updateNews(state, news) {
            state.news = news
        },
        updateRecentNews(state, news) {
            state.recentNews = news
        },
        updateSlide(state, slides) {
            state.slides = slides
        }
    },
    actions: {
        async callSlides({commit}) {
            const result = await get('slider')
            if (!result) return 'error'
            console.log(result.data)
            commit('updateSlide', result.data)
            return 'success'
        },
        async callMain({commit}) {
            const result = await get('banner-footer')
            if (!result) return 'error'
            commit('updateMain', result)
            return 'success'
        },
        async callHome({commit}) {
            const result = await get('home')
            if (!result) return 'error'
            commit('updateHome', result)
            return 'success'
        },
        async callAbout({commit}) {
            const result = await get('aboutus')
            if (!result) return 'error'
            commit('updateAbout', result)
            return 'success'
        },
        async callBreands({commit}) {
            const result = await get('brand')
            if (!result) return 'error'
            commit('updateBrands', result.data)
            return 'success'
        },
        async callShowroom({commit, state}, id) {
            state.showroom = null
            const result = await get('showroom/' + id)
            if (!result) return 'error'
            commit('updateShowroom', result.data)
            return 'success'
        },
        async callCar({commit, state}, id) {
            state.car = null
            const result = await get('car/' + id)
            if (!result) return 'error'
            commit('updateCar', result.data)
            return 'success'
        },
        async callWorkshop({commit, state}) {
            state.car = null
            const result = await get('workshop')
            if (!result) return 'error'
            commit('updateWorkshop', result.data)
            return 'success'
        },
        async callTraining({commit, state}) {
            state.car = null
            const result = await get('training')
            if (!result) return 'error'
            commit('updateTraining', result.data)
            return 'success'
        },
        async callProduction({commit}) {
            const result = await get('production')
            if (!result) return 'error'
            commit('updateProductions', result.data)
            return 'success'
        },
        async callProductionDetail({commit, state}, id) {
            state.production = null
            const result = await get('production-detail/' + id)
            if (!result) return 'error'
            commit('updateProduction', result.data)
            return 'success'
        },
        async callCategory({commit}) {
            const result = await get('news-category')
            if (!result) return 'error'
            commit('updateCategory', result.data)
            return 'success'
        },
        async callNews({commit, state}, {index, category_id}) {
            state.news = null
            const result = (await axios.post(env.apiUrl + 'news?page=' + index, {category_id, 'title': ''})).data
            if (!result) return 'error'
            commit('updateNews', result)
            return 'success'
        },
        async callRecentNews({commit}) {
            const result = (await axios.post(env.apiUrl + 'news?page=1', {category_id: 0, 'title': ''})).data
            if (!result) return 'error'
            commit('updateRecentNews', result.data)
            return 'success'
        },
        async callNewDatail({}, id) {
            const result = await get('news-detail/' + id)
            if (!result) return 'error'
            return result.data
        },
        async callSearch({}, name) {
            const result = await axios.post(env.apiUrl + 'search', {name})
            if (result.status === 200) return result.data.data
            else return false
        },
    }
})
